import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommunicationLogService {

  constructor(private http: HttpClient) { }

  getCommunicationLog(params: any) {
    return this.http.get(environment.ccOpsWebApiUrl + 'api/CommunicationLog/GetCommunicationLog', { params });
  }

  saveCommunicationLog(data: any) {
    return this.http.post(environment.ccOpsWebApiUrl + 'api/CommunicationLog/SaveCommunicationLog', data);
  }

}
